module.exports = __webpack_public_path__ + "img/BruderFritschi.d9fa9e42.svg";